import axios from "axios";
import apiURI from "./Api";

export default class ConfimeaService {
  async confirmEmail(username, token) {
    const bodyJson = {
      username: username,
      token: token,
    };

    const response = await axios.post(`${apiURI}/user/confirmEmail`, bodyJson);
    return response.data;
  }

  async addDocument(username, description, documentCloudinaryId) {
    const bodyJson = {
      username: username,
      description: description,
      documentCloudinaryId: documentCloudinaryId,
    };

    const response = await axios.post(`${apiURI}/user/addDocument`, bodyJson);
    return response.data;
  }
}

